
import moment from 'moment';
import _ from 'lodash';
import gql from "graphql-tag";
import printPDFConsent from "./printPDFConsent.js";
import printPDFConsent2 from "./printPDFConsent2.js";
import api from "../api.ts";
import getPatientsForConsent from "../gql/getPatientsForConsent.gql";
import getInhospitalForConsent from "../gql/getInhospitalForConsent.gql";

  export default {
    name: 'printReportConsent',
    mixins: [printPDFConsent,printPDFConsent2],
    data() {
      return {
        printreport_title:"",
        print_consent_patinet:{
          age:"",
          birthday:"",
          name:"",
          gender:"",
          diagnoses:"",
          created_time:"",
          inHispotalNum:'',
          id_in_hospital:""
        }

      }
    },
    computed: {
      printDiagnoses(){
        return this.$store.state.operationPrintDiagnoses;
      },
      printInhospitalNum(){
        return this.$store.state.operationPrintInHospitaiNum;
      }
    },
    methods: {
      async printConsent(){
        if (this.operationElectiveId && this.editOperation) { // 编辑状态
          if(this.resetOperationDate ===moment(this.appointment.operation_date).format("YYYY-MM-DD")){ // 没有修改日期
            await this.printConsentP()
            }else{
              if(!this.hasMutate){
                this.$message.error("请先确定修改")
              }else{
               await this.printConsentP()
                
              }
            }
        }else{
          if(!this.hasMutate){
            this.$message.error("请先确定预约")
          }else{
            await this.printConsentP()

          }
        }
      },
      async printConsent2(){
        if (this.operationElectiveId && this.editOperation) { // 编辑状态
          if(this.resetOperationDate ===moment(this.appointment.operation_date).format("YYYY-MM-DD")){ // 没有修改日期
            await this.printConsent2P()

            }else{
              if(!this.hasMutate){
                this.$message.error("请先确定修改")
              }else{
                await this.printConsent2P()
    
              }
            }
        }else{
          if(!this.hasMutate){
            this.$message.error("请先确定预约")
          }else{

            await this.printConsent2P()
          }
        }
      },
      async printConsentP(){
       
        if(this.patient_id && this.operationRelevantId){
          await this.getPatinentInfo();
          this.print_consent_patinet.diagnoses = this.printDiagnoses;
          this.print_consent_patinet.inHispotalNum = this.printInhospitalNum

          await this.postInfo();
        }else{
          this.$message.error("请先添加患者信息和相关信息");
        }
      },
      async printConsent2P(){
        if(this.patient_id && this.operationRelevantId){
          await this.getPatinentInfo();
          this.print_consent_patinet.diagnoses = this.printDiagnoses;
          this.print_consent_patinet.inHispotalNum = this.printInhospitalNum

          await this.postInfo2();
        }else{
          this.$message.error("请先添加患者信息和相关信息");
        }
      },
      async getRelevantInfo() {
        // 查询相关信息的最新值，并做填充
        try {
          let res = await this.$apollo.query({
            query: getInhospitalForConsent,
            variables: {
              id: this.operationRelevantId
            },
            fetchPolicy: "no-cache"
          });
          let newData = res.data;
          return
          this.operationDiagnoses.diagnosis_template = this.formatConclusion(
            newData.last_diagnosis_text
          );
          this.diagnosis_template_id = newData.last_diagnosis_text;
          this.operationDiagnoses.past_history = newData.last_past_history;
          this.operationDiagnoses.main_suit = newData.last_main_suit;
          this.operationDiagnoses.id_in_hospital = newData.last_id_inhospital;
        } catch (error) {
          console.log(error);
        }
      },
      async getPatinentInfo() {
        try {
          let res = await this.$apollo.query({
            query: getPatientsForConsent,
            variables: {
              id: this.patient_id
            },
            fetchPolicy: "no-cache"
          });
          let params =  res.data.patient;
          this.print_consent_patinet.birthday =
          params.birthday === this.initialTime
            ? ""
            : moment(params.birthday).format("YYYY-MM-DD");
        this.print_consent_patinet.age = params.age > -1 ? params.age + "" : "";
          this.print_consent_patinet.gender = params.gender;
          this.print_consent_patinet.name = params.name;
          this.print_consent_patinet.created_time = params.created_time;
          this.print_consent_patinet.id_in_hospital = params.id_in_hospital;
        } catch (error) {
          console.log(error);
        }
      },
      openFullScreen() {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 2000);
      }
    }
  };


